import {
  type FlowRealTimeEligibilityBlock,
  FlowRealTimeEligibilityBlockConfigSchema,
} from 'flow-schema';

import { RealTimeEligibilityFormFields } from './FormFields';
import { realTimeEligibilityDocumentation } from './documentation';
import { type BlockConfigProps } from '../../types';

export const realTimeEligibilityConfig: BlockConfigProps<FlowRealTimeEligibilityBlock['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'realTimeEligibility',
  defaultConfig: {
    patientInsuranceInformationId: '',
    npi: '',
  },
  configFields: {
    schema: FlowRealTimeEligibilityBlockConfigSchema,
    FormFields: RealTimeEligibilityFormFields,
  },
  documentationMarkdown: realTimeEligibilityDocumentation,
};
